module.exports = __webpack_public_path__ + "static/media/Instagram.17126eb0.svg";